import React, { Component } from 'react';
import { Button } from 'react-bootstrap';

export default class FieldConfigPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            paramsText: this.getParamsText(props.field),
            paramsError: false
        };
    }

    getParamsText = (field) => {
        if (field && field.dataSource && field.dataSource.params) {
            return JSON.stringify(field.dataSource.params, null, 2);
        }
        return '';
    };

    componentDidUpdate(prevProps) {
        if (prevProps.field !== this.props.field) {
            this.setState({
                paramsText: this.getParamsText(this.props.field),
                paramsError: false
            });
        }
    }

    handleChange = (key, value) => {
        const { field, onUpdateField } = this.props;
        if (!field) return;
        onUpdateField(field.fieldId, { ...field, [key]: value });
    };

    handleValidationChange = (key, value) => {
        const { field, onUpdateField } = this.props;
        if (!field) return;
        const validation = { ...(field.validation || {}), [key]: value };
        onUpdateField(field.fieldId, { ...field, validation });
    };

    handleAddOption = () => {
        const { field, onUpdateField } = this.props;
        if (!field) return;
        const options = [...(field.options || []), { label: '', value: '' }];
        onUpdateField(field.fieldId, { ...field, options });
    };

    handleUpdateOption = (index, key, value) => {
        const { field, onUpdateField } = this.props;
        if (!field) return;
        const options = [...(field.options || [])];
        options[index] = { ...options[index], [key]: value };
        onUpdateField(field.fieldId, { ...field, options });
    };

    handleRemoveOption = (index) => {
        const { field, onUpdateField } = this.props;
        if (!field) return;
        const options = [...(field.options || [])];
        options.splice(index, 1);
        onUpdateField(field.fieldId, { ...field, options });
    };

    handleDataSourceChange = (key, value) => {
        const { field, onUpdateField } = this.props;
        if (!field) return;
        const dataSource = { ...(field.dataSource || {}), [key]: value };
        onUpdateField(field.fieldId, { ...field, dataSource });
    };

    handleConfigChange = (key, value) => {
        const { field, onUpdateField } = this.props;
        if (!field) return;
        const config = { ...(field.config || {}), [key]: value };
        onUpdateField(field.fieldId, { ...field, config });
    };

    render() {
        const { field, sections } = this.props;

        if (!field) {
            return (
                <div style={{ padding: '10px' }}>
                    <h6 style={{ fontWeight: 'bold' }}>Field Configuration</h6>
                    <p className="text-muted" style={{ fontSize: '13px' }}>
                        Select a field on the canvas to edit its properties
                    </p>
                </div>
            );
        }

        const hasOptions = ['select', 'multiselect', 'radio'].includes(field.type);
        const hasDataSource = ['objectIdRef', 'objectIdRefMulti'].includes(field.type);
        const showPhoneConfig = field.type === 'tel';

        return (
            <div style={{ padding: '10px', fontSize: '13px' }}>
                <h6 style={{ fontWeight: 'bold', marginBottom: '15px' }}>
                    Field Configuration
                    <span className="text-muted" style={{ fontWeight: 'normal', fontSize: '11px', display: 'block' }}>
                        {field.fieldId} ({field.type})
                    </span>
                </h6>

                {/* Basic Properties */}
                <div className="form-group mb-2">
                    <label style={{ fontSize: '12px', fontWeight: 'bold' }}>Field ID</label>
                    <input
                        type="text"
                        className="form-control form-control-sm"
                        value={field.fieldId || ''}
                        onChange={(e) => this.handleChange('fieldId', e.target.value)}
                    />
                </div>

                <div className="form-group mb-2">
                    <label style={{ fontSize: '12px', fontWeight: 'bold' }}>Label</label>
                    <input
                        type="text"
                        className="form-control form-control-sm"
                        value={field.label || ''}
                        onChange={(e) => this.handleChange('label', e.target.value)}
                    />
                </div>

                <div className="form-group mb-2">
                    <label style={{ fontSize: '12px', fontWeight: 'bold' }}>Model Path</label>
                    <input
                        type="text"
                        className="form-control form-control-sm"
                        value={field.modelPath || ''}
                        onChange={(e) => this.handleChange('modelPath', e.target.value)}
                        placeholder="e.g. address.city"
                    />
                </div>

                <div className="form-group mb-2">
                    <label style={{ fontSize: '12px', fontWeight: 'bold' }}>Placeholder</label>
                    <input
                        type="text"
                        className="form-control form-control-sm"
                        value={field.placeholder || ''}
                        onChange={(e) => this.handleChange('placeholder', e.target.value)}
                    />
                </div>

                <div className="form-group mb-2">
                    <label style={{ fontSize: '12px', fontWeight: 'bold' }}>Help Text</label>
                    <input
                        type="text"
                        className="form-control form-control-sm"
                        value={field.helpText || ''}
                        onChange={(e) => this.handleChange('helpText', e.target.value)}
                    />
                </div>

                <div className="row mb-2">
                    <div className="col-6">
                        <label style={{ fontSize: '12px', fontWeight: 'bold' }}>Col Span</label>
                        <select
                            className="form-control form-control-sm"
                            value={field.colSpan || 12}
                            onChange={(e) => this.handleChange('colSpan', parseInt(e.target.value))}
                        >
                            <option value={3}>3 (Quarter)</option>
                            <option value={4}>4 (Third)</option>
                            <option value={6}>6 (Half)</option>
                            <option value={8}>8 (Two-thirds)</option>
                            <option value={12}>12 (Full)</option>
                        </select>
                    </div>
                    <div className="col-6">
                        <label style={{ fontSize: '12px', fontWeight: 'bold' }}>Section</label>
                        <select
                            className="form-control form-control-sm"
                            value={field.sectionId || ''}
                            onChange={(e) => this.handleChange('sectionId', e.target.value)}
                        >
                            <option value="">None</option>
                            {(sections || []).map((s) => (
                                <option key={s.sectionId} value={s.sectionId}>{s.label}</option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Validation */}
                <h6 style={{ fontWeight: 'bold', marginTop: '15px', borderTop: '1px solid #eee', paddingTop: '10px' }}>
                    Validation
                </h6>
                <div className="form-check mb-2">
                    <input
                        type="checkbox"
                        className="form-check-input"
                        id="val-required"
                        checked={field.validation && field.validation.required}
                        onChange={(e) => this.handleValidationChange('required', e.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="val-required" style={{ fontSize: '12px' }}>
                        Required
                    </label>
                </div>
                <div className="row mb-2">
                    <div className="col-6">
                        <label style={{ fontSize: '12px' }}>Min Length</label>
                        <input
                            type="number"
                            className="form-control form-control-sm"
                            value={(field.validation && field.validation.minLength) || ''}
                            onChange={(e) => this.handleValidationChange('minLength', e.target.value ? parseInt(e.target.value) : undefined)}
                        />
                    </div>
                    <div className="col-6">
                        <label style={{ fontSize: '12px' }}>Max Length</label>
                        <input
                            type="number"
                            className="form-control form-control-sm"
                            value={(field.validation && field.validation.maxLength) || ''}
                            onChange={(e) => this.handleValidationChange('maxLength', e.target.value ? parseInt(e.target.value) : undefined)}
                        />
                    </div>
                </div>
                <div className="form-group mb-2">
                    <label style={{ fontSize: '12px' }}>Pattern (Regex)</label>
                    <input
                        type="text"
                        className="form-control form-control-sm"
                        value={(field.validation && field.validation.pattern) || ''}
                        onChange={(e) => this.handleValidationChange('pattern', e.target.value)}
                    />
                </div>

                {/* Options (for select/radio) */}
                {hasOptions && (
                    <div>
                        <h6 style={{ fontWeight: 'bold', marginTop: '15px', borderTop: '1px solid #eee', paddingTop: '10px' }}>
                            Options
                        </h6>
                        {(field.options || []).map((opt, i) => (
                            <div key={i} className="row mb-1">
                                <div className="col-5">
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        value={opt.label}
                                        placeholder="Label"
                                        onChange={(e) => this.handleUpdateOption(i, 'label', e.target.value)}
                                    />
                                </div>
                                <div className="col-5">
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        value={opt.value}
                                        placeholder="Value"
                                        onChange={(e) => this.handleUpdateOption(i, 'value', e.target.value)}
                                    />
                                </div>
                                <div className="col-2">
                                    <button
                                        className="btn btn-sm btn-link text-danger"
                                        onClick={() => this.handleRemoveOption(i)}
                                    >
                                        <i className="fa fa-times" />
                                    </button>
                                </div>
                            </div>
                        ))}
                        <Button variant="outline-primary" size="sm" onClick={this.handleAddOption} className="mt-1">
                            <i className="fa fa-plus" /> Add Option
                        </Button>
                    </div>
                )}

                {/* Data Source (for objectIdRef fields) */}
                {hasDataSource && (
                    <div>
                        <h6 style={{ fontWeight: 'bold', marginTop: '15px', borderTop: '1px solid #eee', paddingTop: '10px' }}>
                            Data Source
                        </h6>
                        <div className="form-group mb-2">
                            <label style={{ fontSize: '12px' }}>API Endpoint</label>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                value={(field.dataSource && field.dataSource.endpoint) || ''}
                                placeholder="/facility/v1/"
                                onChange={(e) => this.handleDataSourceChange('endpoint', e.target.value)}
                            />
                        </div>
                        <div className="form-group mb-2">
                            <label style={{ fontSize: '12px' }}>Method</label>
                            <select
                                className="form-control form-control-sm"
                                value={(field.dataSource && field.dataSource.method) || 'GET'}
                                onChange={(e) => this.handleDataSourceChange('method', e.target.value)}
                            >
                                <option value="GET">GET</option>
                                <option value="POST">POST</option>
                            </select>
                        </div>
                        <div className="form-group mb-2">
                            <label style={{ fontSize: '12px' }}>Params (JSON body)</label>
                            <textarea
                                className={'form-control form-control-sm' + (this.state.paramsError ? ' is-invalid' : '')}
                                rows={3}
                                value={this.state.paramsText}
                                placeholder='{"key": "value"}'
                                onChange={(e) => this.setState({ paramsText: e.target.value, paramsError: false })}
                                onBlur={() => {
                                    const val = this.state.paramsText.trim();
                                    if (!val) {
                                        this.handleDataSourceChange('params', undefined);
                                        this.setState({ paramsError: false });
                                    } else {
                                        try {
                                            this.handleDataSourceChange('params', JSON.parse(val));
                                            this.setState({ paramsError: false });
                                        } catch (err) {
                                            this.setState({ paramsError: true });
                                        }
                                    }
                                }}
                            />
                            {this.state.paramsError
                                ? <small className="text-danger">Invalid JSON</small>
                                : <small className="text-muted">Request body for POST calls</small>
                            }
                        </div>
                        <div className="row mb-2">
                            <div className="col-6">
                                <label style={{ fontSize: '12px' }}>Label Field</label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={(field.dataSource && field.dataSource.labelField) || ''}
                                    placeholder="name"
                                    onChange={(e) => this.handleDataSourceChange('labelField', e.target.value)}
                                />
                            </div>
                            <div className="col-6">
                                <label style={{ fontSize: '12px' }}>Value Field</label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={(field.dataSource && field.dataSource.valueField) || ''}
                                    placeholder="_id"
                                    onChange={(e) => this.handleDataSourceChange('valueField', e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="form-check mb-2">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id="ds-selectAll"
                                checked={field.dataSource && field.dataSource.includeSelectAll}
                                onChange={(e) => this.handleDataSourceChange('includeSelectAll', e.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="ds-selectAll" style={{ fontSize: '12px' }}>
                                Include "Select All" option
                            </label>
                        </div>
                    </div>
                )}

                {/* Phone Config */}
                {showPhoneConfig && (
                    <div className="form-check mb-2 mt-2">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id="cfg-formatPhone"
                            checked={field.config && field.config.formatPhone}
                            onChange={(e) => this.handleConfigChange('formatPhone', e.target.checked)}
                        />
                        <label className="form-check-label" htmlFor="cfg-formatPhone" style={{ fontSize: '12px' }}>
                            Auto-format phone number
                        </label>
                    </div>
                )}
            </div>
        );
    }
}
